export default {
    parent: 'PublicLayout',
    url: '/:company?guid',
    params: {
        company: { squash: true, value: null }
    },
    template: '<div/>',
    controller (AuthService, $state, lodash, TokenService) {
        if (AuthService.isLoggedIn()) {
            $state.go('authorized.home', { company: TokenService.getCompanySlug() });
        }
        else {
            if (!lodash.includes(['quiz', 'evaluation', 'survey', 'performance-review'], $state.params.company)) {
                if ($state.params.company) {
                    $state.go('unauthorized.login', { company: $state.params.company });
                }
                else {
                    $state.go('root');
                }
            }
        }
    }
};



// WEBPACK FOOTER //
// ./src/app/states/home/index.js